import _objectSpread from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ProfileDropDown from "./ProfileDropDown.vue";
import { mapGetters } from "vuex";
export default {
  name: "the-navbar-horizontal",
  props: {
    logo: {
      type: String
    },
    navbarType: {
      type: String,
      required: true
    }
  },
  components: {
    ProfileDropDown: ProfileDropDown
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    currentProvider: "profile/currentProvider"
  })), {}, {
    navbarColor: function navbarColor() {
      var color = "#fff";
      if (this.navbarType === "sticky") color = "#f7f7f7";else if (this.navbarType === "static") {
        if (this.scrollY < 50) {
          color = "#f7f7f7";
        }
      }
      this.isThemeDark === "dark" ? color === "#fff" ? color = "#10163a" : color = "#262c49" : null;
      return color;
    },
    isThemeDark: function isThemeDark() {
      return this.$store.state.theme;
    },
    navbarStyle: function navbarStyle() {
      return this.navbarType === "static" ? {
        transition: "all .25s ease-in-out"
      } : {};
    },
    navbarClasses: function navbarClasses() {
      return this.scrollY > 5 && this.navbarType === "static" ? null : "d-theme-dark-light-bg shadow-none";
    },
    scrollY: function scrollY() {
      return this.$store.state.scrollY;
    },
    verticalNavMenuWidth: function verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    windowWidth: function windowWidth() {
      return this.$store.state.windowWidth;
    }
  })
};